<template>
  <div id="allUrlMonitor">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>监控中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/UrlMonitor' }">单链接监控</el-breadcrumb-item>
        <el-breadcrumb-item>单链接监控详情</el-breadcrumb-item>
      </el-breadcrumb>
    <div class="page2">
      <el-row>
        <el-col :span="24">
          <span style="font-size: 18px;">计划信息</span>
        </el-col>
        <el-col :span="24" style="margin-top: 25px;">
          <span>商品名称：</span>
          <a style="color: rgb(16, 140, 238);text-decoration:none" :href="itemlink" target="_blank">{{itemtitle}}</a>
          <span style="margin-left: 140px;">限价：</span>
          <span style="color: #999999;">¥{{itemprice}}</span>
        </el-col>
        <el-col :span="24" style="margin-top: 20px; display: flex;">
          <span>店铺：</span>
          <span style="color: #999999;">{{shopname}}</span>
          <img :src='require("@/assets/img/platform/pla_"+ this.platform +".png")' alt style="width: 18px;height: 18px;margin-top: 2px;margin-left: 5px;">
          <div class="down2" v-show="this.shoptype == 1">授权</div>
          <div class="down3" v-show="this.shoptype == 2">灰</div>
          <div class="down4" v-show="this.shoptype == 3">黑</div>
        </el-col>
      </el-row>
    </div>

    <div class="page">
      <el-row style="margin-bottom: 15px;">
        <el-col :span="10">
          <el-button @click="oneStep(1)" style="margin-right: 10px;" size="small">下载数据</el-button>
        </el-col>
        <el-col :span="14">
          <div class="block2">
            <span style="margin-right: 10px;">变更时间</span>
            <el-date-picker
            v-model="searchformDate"
            size="small"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            range-separator="~"
            :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
        </el-col>
      </el-row>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">
            {{ scope.row.monitor_time | formatDate}}
          </template>
        </el-table-column>
        <el-table-column label="监控信息" style="position: relative;" width="310">
          <template slot-scope="scope">
            <div v-show="scope.row.islowprice == 1" class="down">低</div>
            <el-row>
              <el-col :span="4">
                <el-popover
                  placement="bottom-start"
                  width="220"
                  height="220"
                  trigger="hover">
                  <img :src="scope.row.logopicurl" style="width: 220px;height: 220px;"/>
                  <img slot="reference" :src="scope.row.logopicurl" style="width: 50px;height: 50px;"/>
                </el-popover>

              </el-col>
              <el-col :span="20">
                <div class="imgsess">
                    {{ scope.row.itemtitle }}
                </div>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column label="价格">
          <template slot-scope="scope">
            ¥{{ scope.row.itemprice }}
          </template>
        </el-table-column>
        <el-table-column prop="salevolume" label="销量">
        </el-table-column>
        <el-table-column prop="status" label="状态">
        </el-table-column>
        <el-table-column label="违规快照">
          <template slot-scope="scope">
            <a style="color: #108cee;text-decoration:none" :href="scope.row.lowprice_screenshot" target="_blank" v-show="scope.row.lowprice_screenshot">查看快照</a>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="totalNum > 0">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 30, 40]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import pagination from "../../../components/dataTable/pagination";
  export default {
    data() {
      return {
        itemtitle: '',
        itemlink: '',
        itemprice: '',
        shopname: '',
        shoptype: '',
        totalNum: 100,
        pageNo: 1,
        pageSize: 10,
        currentPage: 1,
        platform: '',
        formLabelWidth: '80px',
        searchformDate: [],
        pickerOptions: {
  				shortcuts: [{
  					text: '最近三个月',
  					onClick:(picker) => {
  						this.getRecentDate(picker);
  					}
  				}]
  			},
        tableData: [],
        multipleSelection: [],
      }
    },
    filters: {
      formatDate: function (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    },
    created(){
  		this.getRecentDate();
  	},
    mounted() {
      this.GetObj();
    },
    methods: {
      // 前三个月时间
  		getRecentDate(picker){
  			const end = new Date();
  			const start = new Date();
  			start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
  			if(picker){
  				picker.$emit('pick', [start, end]);
        }
        this.searchformDate[0] = start;
        this.searchformDate[1] = end;
  		},
      oneStep() {
        let datas={
          start_date: this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0, 10),
          end_date: this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0, 10),
          id: this.$route.query.id,
          itemlink: this.itemlink
        }
        fetch({
            url: "hcm/monitorLink/downLoad",
            method: "get",
            params:datas,
            noFormat: true,
            responseType: "blob"
        })
        .then((res)=>{
          //下载
          let url = window.URL.createObjectURL(new Blob([res]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', '单链接监控详情.xlsx')
          document.body.appendChild(link)
          link.click()
        })
      },
      GetObj() {
        let params={
          id: this.$route.query.id,
        }
        fetch({
          url: "hcm/monitorLink/GetObj",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.itemtitle = data.itemtitle
            this.itemlink = data.itemlink
            this.itemprice = data.itemprice
            this.shopname = data.shopname
            this.shoptype = data.shoptype
            this.platform = data.platform
            this.theQuery();
          }
        })
      },
      theQuery() {
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          start_date: this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0, 10),
          end_date: this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0, 10),
          id: this.$route.query.id,
          itemlink: this.itemlink
        }
        fetch({
          url: "hcm/monitorLink/GetDetailList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableData = data.content;
            this.totalNum = data.totalElements;
          } else if (res.status == '10400') {

          }
        })
        .catch(err => {

        })
      },

      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.theQuery();
      },
      handleCurrentChange(val) {
        console.log(this.pageSize);
        this.pageNo = `${val}`
        this.theQuery();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },

    },
    components: {
      pagination
    }
  }
</script>
<style scoped lang="scss">
  .header {
    width: 100%;
    height: 40px;
    background-color: white;
  }
  .page {
    padding: 20px;
    margin: 20px;
    background-color: white;
  }
  .page2 {
    padding: 20px;
    margin: 20px;
    background-color: white;
  }
  .headerSize {
    line-height: 40px;
    text-align: right;
  }
  .block {
    text-align: right;
    margin-top: 20px;
  }
  .block2 {
    text-align: right;
  }
  .down {
    position: absolute;
    top: 28px;
    left: -15px;
    width: 15px;
    height: 15px;
    background-color: red;
    text-align: center;
    line-height: 15px;
    color: white;
    border-radius: 5px;
    font-size: 6px;
  }
  .down2 {
    height: 15px;
    width: 35px;
    background-color: #52c41a;
    text-align: center;
    line-height: 15px;
    color: white;
    border-radius: 3px;
    font-size: 6px;
    margin-top: 4px;
    margin-left: 5px;
  }
  .down3 {
    width: 20px;
    height: 15px;
    background-color: #999999;
    text-align: center;
    line-height: 15px;
    color: white;
    border-radius: 3px;
    font-size: 6px;
    margin-top: 4px;
    margin-left: 5px;
  }
  .down4 {
    width: 20px;
    height: 15px;
    background-color: #333333;
    text-align: center;
    line-height: 15px;
    color: white;
    border-radius: 3px;
    font-size: 6px;
    margin-top: 4px;
    margin-left: 5px;
  }
  .imgsess{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-left: 10px;
  }

</style>
<style lang="scss">
#allUrlMonitor {
  .el-table th {
    background-color: #f3f7ff !important;
  }
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
  }
  .el-button+.el-button {
    margin-left: 1px;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
}
</style>
